import { SET_WAITING_FOR_LOCATION, LOCATION_DENIED, UPDATE_LOCATION } from './actionTypes';
export var setWaitingForLocation = function setWaitingForLocation(isWaitingForLocation) {
  return {
    type: SET_WAITING_FOR_LOCATION,
    payload: isWaitingForLocation
  };
};
export var showLocationDeniedNotification = function showLocationDeniedNotification() {
  return {
    type: LOCATION_DENIED,
    payload: true
  };
};
export var updateLocation = function updateLocation(_ref) {
  var slug = _ref.slug,
      placeId = _ref.placeId,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      bbox = _ref.bbox,
      currentPlace = _ref.currentPlace,
      currentPlaceParent = _ref.currentPlaceParent,
      placeType = _ref.placeType,
      city = _ref.city,
      region = _ref.region,
      isUsingCurrentLocation = _ref.isUsingCurrentLocation,
      isOnline = _ref.isOnline;
  return {
    type: UPDATE_LOCATION,
    payload: {
      slug: slug,
      placeId: placeId,
      latitude: latitude,
      longitude: longitude,
      bbox: bbox,
      currentPlace: currentPlace,
      currentPlaceParent: currentPlaceParent,
      placeType: placeType,
      city: city,
      region: region,
      isUsingCurrentLocation: isUsingCurrentLocation,
      isOnline: isOnline
    }
  };
};